import React, { useEffect, useState } from 'react';
import { IconType } from 'react-icons';
import { LuBuilding2 } from 'react-icons/lu';

interface ImageWithFallbackIconProps {
    src: string;
    alt: string;
    className?: string;
    fallbackIcon?: IconType;
    fallbackIconClassName?: string;
}

export const ImageWithFallbackIcon = ({
    src,
    alt,
    fallbackIcon,
    className,
    fallbackIconClassName,
}: ImageWithFallbackIconProps) => {
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const Icon = fallbackIcon ?? LuBuilding2;

    const handleError = () => {
        setHasError(true);
        setIsLoading(false);
    };

    useEffect(() => {
        if (!src) return;

        setIsLoading(true);
        setHasError(false);

        // Create a new image to test if it loads
        const img = new window.Image();
        img.onload = () => setIsLoading(false);
        img.onerror = () => {
            setHasError(true);
            setIsLoading(false);
        };
        img.src = src;

        // If image is already cached/complete, set loading to false immediately
        if (img.complete) {
            setIsLoading(false);
        }
    }, [src]);

    if (!src) {
        return <Icon className={fallbackIconClassName || className} />;
    }

    return (
        <>
            {!isLoading && !hasError ? (
                <img
                    className={className}
                    src={src}
                    alt={alt}
                    onLoad={() => setIsLoading(false)}
                    onError={handleError}
                />
            ) : (
                <Icon className={fallbackIconClassName || className} />
            )}
        </>
    );
};
